<ion-label [ngStyle]="question.css">
  <h1>{{ question.label }}</h1>
</ion-label>
